module.exports = __webpack_public_path__ + "static/media/DefaultProfileImage.10fdd805.png";